module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "now-date"
  }, [_vm._v(_vm._s(_vm.nowDate))]), _vm._v(" "), _c('div', {
    staticClass: "calendar-box"
  }, [_c('div', {
    staticClass: "calendar-week flex"
  }, _vm._l((_vm.calendarWeek), function(item) {
    return _c('div', {
      staticClass: "flex-1 relative"
    }, [_vm._v(_vm._s(item) + " ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "calendar-date flex"
  }, _vm._l((_vm.getCountDays), function(item) {
    return _c('div', {
      staticClass: "relative",
      class: {
        active: _vm.addClass(item) || _vm.nowDay == item
      }
    }, [_vm._v(_vm._s(item)), _c('i', {
      staticClass: "check"
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "text",
    class: {
      active: _vm.getNum
    }
  }, [_vm._v("今日签到奖励 酒币"), _c('span', {
    staticClass: "red"
  }, [_vm._v("+" + _vm._s(_vm.getNum))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7066051f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSignIn/Calendar.vue
// module id = 588
// module chunks = 0